import { fetchApi } from '@inmagik/react-crud'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import ReactDatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useAuth } from '../../../auth'
import MaterialIcon from '../../../components/MaterialIcon'
import Paginator from '../../../components/Paginator'
import { SegmentedControlLink } from '../../../components/SegmentedControlLink'
import SelectAutoCompleteFilter from '../../../components/SelectAutocompleteFilter'
import { API_URL, ESITI, INTERVENTI_OPTIONS_TAB, STATI_INTERVENTO, TIPI_INTERVENTO } from '../../../constants'
import { useQsFilters } from '../../../hooks/filters'
import { useInterventiList } from '../../../hooks/interventi'
import { areFiltersActive, interventiInitFilters } from '../InterventiFilters'
import { InterventiTable } from '../InterventiTable'

export default function InterventiCliente() {
  const { filters, uiFilters, setFilters } = useQsFilters(interventiInitFilters)
  const interventi = useInterventiList({
    search: filters.search,
    ordering: filters.ordering,
    page: String(filters.page),
    tipo_intervento: filters.tipo_intervento,
    stato: filters.stato,
    esito: filters.esito,
    cliente: filters.cliente,
    data_intervento__gte: filters.data_intervento__gte,
    data_intervento__lte: filters.data_intervento__lte,
    search_bilancia: filters.bilancia,
  })

  const { tokens } = useAuth()

  const [isDownloadInterventiXlsx, setIsDownloadInterventiXlsx] = useState(false)

  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12">
          <h1 className="title">Interventi</h1>
        </div>
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <SegmentedControlLink
              value={INTERVENTI_OPTIONS_TAB.interventi.value}
              options={Object.values(INTERVENTI_OPTIONS_TAB)}
            />

            <div className="d-flex align-items-center">
              <Button
                disabled={isDownloadInterventiXlsx || (interventi.data && interventi?.data?.count > 1000)}
                onClick={async () => {
                  setIsDownloadInterventiXlsx(true)
                  const data = await fetchApi(
                    `${API_URL}/bilance/intervento/download-xlsx-interventi/?${new URLSearchParams({
                      search: filters.search,
                      ordering: filters.ordering,
                      tipo_intervento: filters.tipo_intervento,
                      stato: filters.stato,
                      esito: filters.esito,
                      cliente: filters.cliente,
                      data_intervento__gte: filters.data_intervento__gte,
                      data_intervento__lte: filters.data_intervento__lte,
                      search_bilancia: filters.bilancia,
                    })}`,
                    {
                      headers: {
                        Authorization: `Bearer ${tokens?.access}`,
                      },
                    }
                  )
                  const blob = await data.blob()
                  const url = window.URL.createObjectURL(blob)
                  const a = document.createElement('a')
                  a.href = url

                  a.download = 'elenco-interventi.xlsx'
                  a.click()
                  setIsDownloadInterventiXlsx(false)
                }}
                variant="outline-secondary"
                className="d-flex align-items-center bg-white me-2 text-secondary"
                type="button"
              >
                <MaterialIcon icon="download" className="me-2" />
                Scarica Excel
                {isDownloadInterventiXlsx && (
                  <Spinner animation="border" variant="secondary" className="ms-4" size="sm" />
                )}
              </Button>
            </div>
          </div>
        </div>
        <div className="col-12 mt-2 filters-block">
          <div
            className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded"
            style={{ overflowX: 'auto' }}
          >
            <div className="d-flex align-items-center w-100">
              <div className="form-group d-flex align-items-center">
                <label className="label-m text-body-secondary me-2 ms-2">Periodo</label>
                <ReactDatePicker
                  selectsRange={true}
                  isClearable
                  placeholderText="Filtra per data intervento"
                  className="form-control me-2 text-secondary"
                  startDate={filters.data_intervento__gte !== '' ? dayjs(filters.data_intervento__gte).toDate() : null}
                  endDate={filters.data_intervento__lte !== '' ? dayjs(filters.data_intervento__lte).toDate() : null}
                  dateFormat={'dd/MM/yyyy'}
                  onChange={(date) => {
                    if (!date[0]) {
                      setFilters({
                        data_intervento__gte: '',
                        data_intervento__lte: '',
                        page: 1,
                      })
                    } else {
                      if (date[0]) {
                        setFilters({
                          data_intervento__gte: dayjs(date[0]).format('YYYY-MM-DD'),
                          data_intervento__lte: date[1] ? dayjs(date[1]).format('YYYY-MM-DD') : '',
                          page: 1,
                        })
                      }
                    }
                  }}
                />
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Cliente</label>
                <div style={{ width: '230px' }}>
                  <SelectAutoCompleteFilter
                    className="interventi-cliente-filter"
                    value={uiFilters.cliente ?? ''}
                    placeholder="Cerca cliente"
                    onChange={(value: any) => {
                      if (!value) {
                        return setFilters({
                          cliente: '',
                          page: 1,
                        })
                      } else {
                        setFilters({
                          cliente: value.value,
                          page: 1,
                        })
                      }
                    }}
                    url={`${API_URL}/bilance/cliente/options`}
                    isMulti={false}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Tipo</label>

                <select
                  className={classNames('form-select me-2', {
                    'text-secondary': uiFilters.tipo_intervento !== '',
                  })}
                  style={{ width: '190px' }}
                  value={uiFilters.tipo_intervento}
                  onChange={(e) => setFilters({ tipo_intervento: e.target.value, page: 1 })}
                >
                  <option value="">Tipo intervento</option>
                  {TIPI_INTERVENTO.map((tipo) => (
                    <option key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Stato</label>
                <select
                  className={classNames('form-select me-2', {
                    'text-secondary': uiFilters.stato !== '',
                  })}
                  style={{ width: '170px' }}
                  value={uiFilters.stato}
                  onChange={(e) => setFilters({ stato: e.target.value, page: 1 })}
                >
                  <option value="">Stato intervento</option>
                  {STATI_INTERVENTO.map((stato) => (
                    <option key={stato.value} value={stato.value}>
                      {stato.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Esito</label>
                <select
                  className={classNames('form-select me-2', {
                    'text-secondary': uiFilters.esito !== '',
                  })}
                  style={{ width: '170px' }}
                  value={uiFilters.esito}
                  onChange={(e) => setFilters({ esito: e.target.value, page: 1 })}
                >
                  <option value="">Esito intervento</option>
                  {ESITI.map((esito) => (
                    <option key={esito.value} value={esito.value}>
                      {esito.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Bilancia</label>
                <input
                  className={classNames('form-control me-2')}
                  style={{ width: '170px' }}
                  value={uiFilters.bilancia}
                  onChange={(e) => setFilters({ bilancia: e.target.value, page: 1 })}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <InterventiTable interventi={interventi} />
          <div className="position-relative">
            <div
              className="position-absolute d-flex align-items-center"
              style={{
                top: '50%',
                left: 20,
                transform: 'translateY(-50%)',
              }}
            >
              <Button
                variant={
                  uiFilters.data_intervento__gte === dayjs().format('YYYY-MM-DD') &&
                  uiFilters.data_intervento__lte === dayjs().format('YYYY-MM-DD')
                    ? 'primary'
                    : 'outline-primary'
                }
                className="d-flex align-items-center me-2"
                type="button"
                onClick={() => {
                  // go to today
                  setFilters({
                    page: 1,
                    search: '',
                    ordering: '-data_intervento',
                    tipo_intervento: '',
                    stato: '',
                    esito: '',
                    cliente: '',
                    data_intervento__gte: dayjs().format('YYYY-MM-DD'),
                    data_intervento__lte: dayjs().format('YYYY-MM-DD'),
                  })
                }}
              >
                <MaterialIcon icon="today" className="me-2" />
                <span> Oggi</span>
              </Button>
              {areFiltersActive(uiFilters) && (
                <Button
                  variant="outline-secondary"
                  className="d-flex align-items-center"
                  type="button"
                  onClick={() => {
                    setFilters({
                      page: 1,
                      search: '',
                      ordering: '-data_intervento',
                      tipo_intervento: '',
                      stato: '',
                      esito: '',
                      cliente: '',
                      data_intervento__gte: '',
                      data_intervento__lte: '',
                    })
                  }}
                >
                  <span className="material-icons me-2">filter_alt_off</span>
                  <span>Reset filtri</span>
                </Button>
              )}
            </div>
            <Paginator
              count={interventi?.data?.count ?? 0}
              currentPage={uiFilters.page}
              goToPage={(page) => setFilters({ page })}
            />
            <div
              className="me-2 text-nowrap position-absolute"
              style={{
                // bottom: c
                right: 20,
                // center in the middle of paginator
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            >
              Stai visualizzando {interventi?.data?.count ?? 0} di {interventi?.data?.full_count ?? 0} interventi
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
